function cov_3dq65pc7c() {
  var path = "/app/src/components/default-promo-widget/components/default-snippet/default-snippet.tsx";
  var hash = "4147b73e83804b686fe2fe0b6aa076a8ee63ce79";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/default-promo-widget/components/default-snippet/default-snippet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 27
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 8,
          column: 48
        }
      },
      "2": {
        start: {
          line: 15,
          column: 30
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "3": {
        start: {
          line: 16,
          column: 23
        },
        end: {
          line: 16,
          column: 38
        }
      },
      "4": {
        start: {
          line: 17,
          column: 12
        },
        end: {
          line: 17,
          column: 23
        }
      },
      "5": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 18,
          column: 51
        }
      },
      "6": {
        start: {
          line: 19,
          column: 16
        },
        end: {
          line: 19,
          column: 33
        }
      },
      "7": {
        start: {
          line: 20,
          column: 19
        },
        end: {
          line: 20,
          column: 41
        }
      },
      "8": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "9": {
        start: {
          line: 23,
          column: 24
        },
        end: {
          line: 23,
          column: 72
        }
      },
      "10": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 76
        }
      },
      "11": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 29,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 8
          },
          end: {
            line: 8,
            column: 48
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 30
          },
          end: {
            line: 15,
            column: 31
          }
        },
        loc: {
          start: {
            line: 15,
            column: 54
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 22,
            column: 18
          },
          end: {
            line: 22,
            column: 19
          }
        },
        loc: {
          start: {
            line: 22,
            column: 24
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 24
          },
          end: {
            line: 23,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 23,
            column: 32
          },
          end: {
            line: 23,
            column: 67
          }
        }, {
          start: {
            line: 23,
            column: 70
          },
          end: {
            line: 23,
            column: 72
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4147b73e83804b686fe2fe0b6aa076a8ee63ce79"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_3dq65pc7c = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_3dq65pc7c();
import React from 'react';
import { lazily } from 'react-lazily';
import { COUNTRY_BY_CURRENCY_MAP } from 'src/constants/country-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
var _ref = (cov_3dq65pc7c().s[0]++, lazily(function () {
    cov_3dq65pc7c().f[0]++;
    cov_3dq65pc7c().s[1]++;
    return import('src/components/snippet-default');
  })),
  SnippetDefault = _ref.SnippetDefault;
cov_3dq65pc7c().s[2]++;
export var DefaultSnippet = function DefaultSnippet(_ref2) {
  var onClick = _ref2.onClick;
  cov_3dq65pc7c().f[1]++;
  var _ref3 = (cov_3dq65pc7c().s[3]++, useAppContext()),
    currency = _ref3.currency;
  var t = (cov_3dq65pc7c().s[4]++, useLocale());
  var country = (cov_3dq65pc7c().s[5]++, COUNTRY_BY_CURRENCY_MAP[currency]);
  var isKSA = (cov_3dq65pc7c().s[6]++, country === 'KSA');
  var linkText = (cov_3dq65pc7c().s[7]++, t('default.learnMore'));
  cov_3dq65pc7c().s[8]++;
  var getText = function getText() {
    cov_3dq65pc7c().f[2]++;
    var shariahText = (cov_3dq65pc7c().s[9]++, isKSA ? (cov_3dq65pc7c().b[0][0]++, "".concat(t('default.shariahCompliant'), ".")) : (cov_3dq65pc7c().b[0][1]++, ''));
    cov_3dq65pc7c().s[10]++;
    return "".concat(t('paid_plans.split_your_purchase_monthly'), ". ").concat(shariahText);
  };
  cov_3dq65pc7c().s[11]++;
  return /*#__PURE__*/React.createElement(SnippetDefault, {
    message: getText(),
    linkText: linkText,
    onClick: onClick
  });
};